/* eslint-disable @typescript-eslint/no-explicit-any */
import { notification } from 'antd';
import { atom } from 'jotai';
import { FileManageServices } from 'src/libs/services/file-manage.service';


export const ListFileUploadedAtom = atom<any[]>([]);

export const getListFileUploadedAtom = atom(
  null,
  async (get, set, params?: any) => {
    try {
      const response = await FileManageServices.getAllFiles();
      const data = response.data;
      set(ListFileUploadedAtom, data);
    } catch (error: any) {
      set(ListFileUploadedAtom, []);
      notification.error({ message: error?.data?.error?.message})
    }
  }
);

export const openListFileUploadedAtom = atom<boolean>(false);

export const openModalUploadFilesAtom = atom<boolean>(false);


